import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { Router } from "@angular/router";
import { EXPLORE_MENU, EMAIL_US } from "src/app/constant/routes";

@Component({
  selector: "app-header-mobile",
  templateUrl: "./header-mobile.component.html",
  styleUrls: ["./header-mobile.component.scss"],
})
export class HeaderMobileComponent implements OnInit {
  @Output() goBack: EventEmitter<boolean> = new EventEmitter();
  @Input() headerTitle: string = "";
  @Input() showSaveButton = false;
  @Input() showMenu = false;
  @Input() showDots = false;

  @Input() showMenuButton = false;
  @Output() onCancel: EventEmitter<any> = new EventEmitter();

  @Output() onSave: EventEmitter<any> = new EventEmitter();
  @Input() showSettings: boolean = false;
  @Input() buttonText: string = null;

  @Input() hideBack: boolean = false;
  constructor(private router: Router) {}

  ngOnInit(): void {
    // console.log(this.hideBack);
  }

  onExploreMenu() {
    this.router.navigate([EXPLORE_MENU.fullUrl], {
      queryParams: { category: "Biryani" },
    });
  }

  emailUs() {
    this.router.navigate([EMAIL_US.fullUrl]);
  }
}
